import Vue from 'vue';
import kafposForm from './kafpos-form/kafpos-form.vue';
Vue.component('kafpos-form', kafposForm);
